/* ZERNO product gallery.
   Native CSS scroll-snap. No JS runs during the swipe, so the gesture stays
   on the compositor thread. JS only syncs the thumbnails. */
(function () {
  function setup(slider) {
    if (slider.__zg) return;
    slider.__zg = true;

    var slides = slider.querySelectorAll('[data-product-single-media-wrapper]');
    if (slides.length < 2) return;

    var scope = slider.closest('product-info') || document;
    var thumbsWrap = scope.querySelector('[data-zerno-gal-thumbs]');
    var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('.product-single__thumbnail') : [];

    var lastActive = -1;

    function activate(i) {
      if (i === lastActive) return;          /* nothing changed, do no work */
      lastActive = i;

      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].classList.toggle('is-active', t === i);
      }

      /* keep the active thumbnail in view: scroll the rail to centre it */
      var el = thumbs[i];
      if (!el || !thumbsWrap) return;
      var railW = thumbsWrap.clientWidth;
      var max = thumbsWrap.scrollWidth - railW;
      if (max <= 0) return;                  /* rail fits, nothing to scroll */
      var target = el.offsetLeft - (railW / 2) + (el.offsetWidth / 2);
      if (target < 0) target = 0;
      if (target > max) target = max;
      thumbsWrap.scrollTo({ left: target, behavior: 'smooth' });
    }

    /* click a thumbnail -> scroll to that slide */
    for (var i = 0; i < thumbs.length; i++) {
      (function (index) {
        thumbs[index].addEventListener('click', function (e) {
          var link = e.target.closest('a');
          if (link) e.preventDefault();
          if (!slides[index]) return;
          slider.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
          activate(index);
        });
      })(i);
    }

    /* scroll -> highlight the nearest thumbnail (passive, frame-throttled) */
    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var mid = slider.scrollLeft + slider.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        for (var s = 0; s < slides.length; s++) {
          var c = slides[s].offsetLeft + slides[s].offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = s; }
        }
        activate(best);
        ticking = false;
      });
    }, { passive: true });

    activate(0);
  }

  function boot() {
    var g = document.querySelectorAll('[data-zerno-gal]');
    for (var i = 0; i < g.length; i++) setup(g[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
